(function () {
    'use strict';
    angular
        .module('app.widgets')
        .directive('obtErrorImage', obtErrorImage);


    function obtErrorImage () {
        return {
            link: function(scope, element, attrs) {
                element.bind('error', function() {
                    if (attrs.src != attrs.errSrc) {
                        attrs.$set('src', attrs.errSrc);
                    }
                });
            }
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-errorImage.directive.js
 ** module id = 180
 ** module chunks = 0
 **/